import { getCancellationSignal } from "../cancellation";

const promiseMap = new WeakMap<Object, Promise<never>>();

/**
 * Returns a promise that gets rejected when the given context gets cancelled
 * via {@link cancelContext}.
 */
export default function getCancellationPromise(context: any) {
	if(!promiseMap.has(context)) {
		const signal = getCancellationSignal(context);
		if(signal == null) {
			return undefined;
		}
		const promise = signal.aborted
			? Promise.reject(signal.reason)
			: new Promise<never>((_, reject) => {
				signal.addEventListener('abort', () => {
					reject(signal.reason);
				}, { once: true });
			});
		
		promiseMap.set(context, promise);
	}
	return promiseMap.get(context)!;
}
